module.exports = __webpack_public_path__ + "static/img/nvxingyongpin.b93d17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/fl/nvxingyongpin.png
// module id = qtZR
// module chunks = 0